// import React, { useState } from "react";

// export const DisplayNewProsuctLayout = ({ data }) => {
// console.log(data);
// const [mainImages, setMainImages] = useState(
//     data.map((department) => department.iconUrl) // Initialize main images
// );

// const handleImageSwap = (departmentIndex, galleryImageIndex) => {
//     // Create a copy of the main images and the department's gallery images
//     const updatedMainImages = [...mainImages];
//     const updatedGalleryImages = [...data[departmentIndex].images];

//     // Swap the main image with the clicked gallery image
//     const temp = updatedMainImages[departmentIndex];
//     updatedMainImages[departmentIndex] =
//     updatedGalleryImages[galleryImageIndex];
//     updatedGalleryImages[galleryImageIndex] = temp;

//     // Update the state for main images
//     setMainImages(updatedMainImages);

//     // Update the data object directly (not modifying original)
//     data[departmentIndex].images = updatedGalleryImages;
// };

// return (
//     <div className="container">
//     {data.map((department, index) => (
//         <div className="Products-container" key={index}>
//         {/* Image Section */}
//         <div className="image-section">
//             <img
//             src={mainImages[index]}
//             alt={department.title}
//             className="main-image"
//             />
//         </div>

//         {/* Content Section */}
//         <div className="content-section">
//             <h1
//             className="title"
//             style={{
//                 backgroundColor: "rgb(63, 72, 204)",
//                 padding: "20px",
//                 color: "white",
//             }}
//             >
//             {department.title}
//             </h1>

//             <ul>
//             {department.datalist.map((item, idx) => (
//                 <li key={idx}>{item}</li>
//             ))}
//             </ul>
//             {/* Gallery */}
//             {/* <div className="gallery">
//             {department.images.map((image, galleryIndex) => (
//                 <img
//                 key={galleryIndex}
//                 src={image}
//                 alt={`${department.title} ${galleryIndex}`}
//                 // onClick={() => handleImageSwap(index, galleryIndex)}
//                 className="gallery-image"
//                 />
//             ))}
//             </div> */}
//         </div>
//         </div>
//            <div className="row">
//            <div className="col-12">
//            <div className="gallery">
//            {data.map((images, index) => {
//                <img
//                key={index}
//                src={images.images}
//                // onClick={() => handleImageSwap(index, galleryIndex)}
//                className="gallery-image"
//                />;
//            })}
//                </div>
//            </div>
//        </div>
//     ))}

//     </div>
// );
// };
import React, { useState } from "react";

export const DisplayNewProsuctLayout = ({ data }) => {
  console.log(data);

  // Initialize main images state
  const [mainImages, setMainImages] = useState(
    data.map((department) => department.iconUrl)
  );

  const handleImageSwap = (departmentIndex, galleryImageIndex) => {
    // Create a copy of the main images and the department's gallery images
    const updatedMainImages = [...mainImages];
    const updatedGalleryImages = [...data[departmentIndex].images];

    // Swap the main image with the clicked gallery image
    const temp = updatedMainImages[departmentIndex];
    updatedMainImages[departmentIndex] = updatedGalleryImages[galleryImageIndex];
    updatedGalleryImages[galleryImageIndex] = temp;

    // Update the state for main images
    setMainImages(updatedMainImages);

    // Update the data object directly (not modifying original)
    data[departmentIndex].images = updatedGalleryImages;
  };

  return (
    <div className="container">
      {data.map((department, index) => (
        <>
        <div className="main-products-box">
        <div className="Products-container" key={index}>
          {/* Image Section */}
          <div className="image-section">
            <img
              src={mainImages[index]}
              alt={department.title}
              className="main-image"
            />
          </div>

          {/* Content Section */}
          <div className="content-section">
            <h1
              className="title"
              style={{
                backgroundColor: "rgb(63, 72, 204)",
                padding: "10px",
                color: "white",
                fontSize:"16px",
                textAlign:"center   ",
                width:"100%"
              }}
            >
              {department.title}
            </h1>

            <ul>
              {department.datalist.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>

            {/* Gallery Section */}
         
          </div>
        </div>
        <div className="gallery">
              {department.images.map((image, galleryIndex) => (
                <img
                  key={galleryIndex}
                  src={image}
                  alt={`${department.title} ${galleryIndex}`}
                 
                  className="gallery-image"
                />
              ))}
            </div>
        </div>
       
        </>
      ))}
    </div>
  );
};
